export enum FeedbackActionTypes {
  SET_FEEDBACK_STATE = "@feedback/setFeedbackState",
  SET_FEEDBACK_AVAILABLE = "@feedback/setFeedbackAvailable"
}

export interface IFeedbackState {
  readonly showFeedback: boolean;
  readonly isFeedbackAvailable: boolean;
}

export interface ISetFeedback {
  type: FeedbackActionTypes;
  payload: boolean;
}

export type FeedbackActions = ISetFeedback;
